const m = window.require("jquery");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;